import { authLoginFormControlLocaleTexts } from './control'
import { authLoginFormInputLocaleTexts } from './input'
import { authLoginFormToastLocaleTexts } from './toast'

export const authLoginFormLocaleTexts = {
  input: authLoginFormInputLocaleTexts,
  control: authLoginFormControlLocaleTexts,
  toast: authLoginFormToastLocaleTexts,
}
